import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getAdminSession } from '../../redux/saga/cognito/actions';
import Spinner from '../../components/loader/spinner';

function BibRoute({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const adminSession = useSelector(state => state.adminSession);

  useEffect(() => {
    dispatch(getAdminSession());
  }, [dispatch]);

  if (adminSession.loading) {
    return (
      <div className="min-height flex items-center">
        <Spinner color="black" size="large" />
      </div>
    );
  }

  // Check if user has admin access for bibs
  const hasBibAccess = adminSession.logged;

  return hasBibAccess ? children : <Navigate to="/bib-login" state={{ from: location }} replace />;
}

BibRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BibRoute;
